var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/forward"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 19.96V37.04C5 40.54 8.80332 42.7334 11.8367 40.9834L19.2333 36.7367L26.63 32.4667C27.0966 32.1867 27.47 31.8834 27.7734 31.51V25.5367C27.47 25.1634 27.0966 24.86 26.63 24.58L19.2333 20.31L11.8367 16.0634C8.80332 14.2667 5 16.46 5 19.96Z",
    stroke: "#2EC4B6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.7732 19.96V37.04C27.7732 40.54 31.5765 42.7334 34.6098 40.9834L42.0065 36.7367L49.4032 32.4667C52.4365 30.7167 52.4365 26.3534 49.4032 24.58L42.0065 20.31L34.6098 16.0634C31.5765 14.2667 27.7732 16.46 27.7732 19.96Z",
    stroke: "#2EC4B6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.285ec869d154708abd99ca372f62d358.svg";
export { ForwardRef as ReactComponent };